import { API_SETMEAL_LIST } from '@constant'
import http, { createApi } from '@core/fetch'
import { isSiDaTeam } from '@util'
import { isSiDaProperty } from '@merchant-backend/util'

const API_GROUP_SETMEAL_LIST = '/p/wedding/mainAdmin/APISetMeal/sortList'

export default {
  // 获取灰度城市
  getGrayCity: createApi.get(
    '/hms/mainLocalService/appApi/channel/commonSetting'
  ),
  // 登录后是否默认跳转到装修
  getTheme: createApi('/p/wedding/Home/APIMerchant/decoration'),
  setTheme: createApi.post('/p/wedding/Admin/APIMerchant/chose_theme_v2', {
    onError: false
  }),
  ifToDecoration: createApi('/p/wedding/Admin/APIMerchant/AppDefaultTab'),
  getHomeData: createApi('/p/wedding/Home/APIMerchant/detailMerchantV3'),
  getMerchantHomeData: createApi('/p/wedding/Home/APIMerchant/merchant_index'),
  goodExamples: createApi('/p/wedding/Admin/APIMerchant/GoodExamples'),
  mealCaseList: body => {
    return http(
      isSiDaTeam()
        ? API_GROUP_SETMEAL_LIST
        : '/p/wedding/index.php/home/APISetMeal/list',
      {
        body
      }
    )
  },
  mealCaseProperty: createApi(
    '/p/wedding/home/APISetMeal/merchant_index_properties'
  ),
  mealCasePropertyV2: createApi('/p/wedding/Home/APISetMeal/case_list'),
  qaList: createApi('/p/wedding/Home/APIQaQuestion/list'),
  // 商家动态
  merchantUpdates: createApi(
    isSiDaProperty()
      ? '/p/wedding/index.php/home/APINote/merchantNotes'
      : '/p/wedding/index.php/home/APINote/my_notes'
  ),
  easyChat: createApi('/p/wedding/home/APIMerchantChatlink'),
  adminEasyChat: createApi('/p/wedding/admin/APIMerchantChatlink'),
  easyChatList: createApi('/p/wedding/Admin/APIMerchantChatlink/check'),
  chatEditApi: createApi.post('/p/wedding/Admin/APIMerchantChatlink/edit'),
  openEasyChat: createApi.post('/p/wedding/Admin/APIMerchantChatlink/active'),
  commentList: createApi(
    '/p/wedding/index.php/Home/APIOrderComment/merchantCommentList'
  ),
  allStatus: createApi('/p/wedding/Admin/APIMerchant/merchant_check_status'),
  intro: createApi('/p/wedding/Admin/APIMerchant/merchant_check_status'),
  panoList: createApi('/p/wedding/index.php/Admin/APIMerchantPano/allPanoList'),
  partial_edit: createApi.post('/p/wedding/Admin/APIMerchant/partial_edit'),
  videoList: createApi('/p/wedding/Home/APIMerchant/video_list'),
  addVideo: createApi.post('/p/wedding/Admin/APIMerchantVideo/add'),
  deleteVideo: createApi.delete('/p/wedding/Admin/APIMerchantVideo/delete'),
  changeVideoOrder: createApi.post(
    '/p/wedding/Admin/APIMerchantVideo/exchange_order'
  ),
  verifyVideo: createApi.post('/p/wedding/Admin/APIMerchantVideo/audit'),
  // 非店铺服务（收费）商家获取已设置的店铺服务（收费）版功能数量
  getProItem: createApi(
    '/p/wedding/index.php/admin/APIMerchant/ulimate_item_count'
  ),
  mealList: body => {
    return http(isSiDaTeam() ? API_GROUP_SETMEAL_LIST : API_SETMEAL_LIST, {
      body
    })
  },
  // 作品列表
  caseList: createApi('/p/wedding/index.php/Home/APISetMeal/case_list'),
  // 推荐橱窗上移
  windowUp: createApi.post(
    '/p/wedding/index.php/Admin/APIMerchantRecommendMeal/up_seat'
  ),
  // 取消推荐橱窗
  deleteShowCaseApi: createApi.post(
    '/p/wedding/index.php/Admin/APIMerchantRecommendMeal/cancel'
  ),
  privilegeList: createApi(
    '/p/wedding/Admin/APIMerchantPrivilege/current_list',
    {
      expect: null
    }
  ),
  // 款式管理列表
  styleManageList: createApi('/hms/hljLocalserviceProduct/adminApi/style/list'),

  editPrivilege: createApi.post('/p/wedding/Admin/APIMerchantPrivilege/edit'),
  addPrivilege: createApi.post('/p/wedding/Admin/APIMerchantPrivilege/add'),
  // 套餐热标修改
  editMealTag: createApi.post('/p/wedding/Admin/APISetMeal/tag_v2'),
  // http://doc.hunliji.com/workspace/myWorkspace.do?projectId=32#2095
  showCaseListApi: createApi(
    '/p/wedding/index.php/Admin/APIMerchantRecommendMeal/lists'
  ),
  templateApi: createApi('/p/wedding/Admin/APIMerchantChatlink/template', {
    expect: []
  }),
  commentTag: createApi('/p/wedding/home/APIOrderComment/order_comment_tags'),
  // 获取商家活动列表
  getMerchantActivityList: body =>
    http('/p/wedding/Admin/APIWcdActivity/activity_list', { body }),
  // 获取商家设置的活动
  getMerchantActiveActivity: createApi(
    '/hms/hljUtils/appApi/admin/homeActivity/detail'
  ),
  // 提交商家修改的活动数据
  postActivitySetting: body =>
    http.post('/hms/hljUtils/appApi/admin/homeActivity/edit', {
      body
    }),
  // 删除商家绑定的活动
  deleteMerchantActivity: body =>
    http.post('/hms/hljUtils/appApi/admin/homeActivity/remove', {
      body
    }),
  // 获取商家视频创意中心视频列表
  getLibraryVideoList: body =>
    http('/p/wedding/Admin/APIMerchantMaterials/merchant_video_list', { body }),
  // 获取商家直播视频列表
  getLiveVideoList: body =>
    http('/p/wedding/admin/APILiveChannel/historyList', { body }),
  // 商家视频上传
  uploadMerchantVideo: body =>
    http.post('/p/wedding/Admin/APIMerchantVideo/add', { body }),
  // 从创意中心列表中添加视频
  addLibraryMerchantVideo: body =>
    http.post('/p/wedding/Admin/APIMerchantVideo/add_materials', { body }),
  // 从直播视频列表中添加视频
  addLiveMerchantVideo: body =>
    http.post('/p/wedding/Admin/APIMerchantVideo/add_live', { body }),
  adminVideoList: createApi('/p/wedding/Admin/APIMerchantVideo/list'),
  getJiaMengGoods: createApi(
    '/p/wedding/index.php/home/APISetMeal/merchant_product_list'
  ),
  getJiaMengPropertyList: createApi(
    '/p/wedding/admin/APIMerchantProperties/show_property_list'
  ),
  // 获取分类与每个分类下的前四个单品
  getAllProducts: createApi(
    '/p/wedding/Admin/APISetMealSingleProduct/CategoryItemAll'
  ), // 获取分类下的所有单品
  setHotTag: createApi.post(
    '/p/wedding/Admin/APISetMealSingleProduct/SetHotTag'
  ), // 设置镇店之宝
  sortSingleProduct: createApi.post(
    '/p/wedding/Admin/APISetMealSingleProduct/ItemChangeSort'
  ), // 单品排序
  sortCategory: createApi.post(
    '/p/wedding/Admin/APISetMealSingleProduct/CategoryChangeSort'
  ), // 分类排序
  getSeriesList: createApi('/p/wedding/index.php/Admin/APISeries/series'),
  // 套餐案例拖动排序
  setMealSort: createApi.post('/p/wedding/Admin/APISetMeal/drag_sort'),

  // 店铺装修款式类目
  getDecorationStyleList: createApi(
    '/hms/hljLocalserviceProduct/adminApi/setMeal/style/categoryStyleList'
  ),

  // 店铺装修款式相册预览列表
  getDecorationStylePreviewList: createApi(
    '/hms/hljLocalserviceProduct/appApi/style/styleList'
  ),

  // 店铺装修获取全部款式
  getAllStyleProducts: createApi(
    '/hms/hljLocalserviceProduct/adminApi/setMeal/style/list'
  ),

  // 店铺装修款式类目排序
  sortStyleCategoryList: createApi.post(
    '/hms/hljLocalserviceProduct/adminApi/setMeal/style/category/sort'
  ),

  // 店铺装修款式排序
  sortStyleList: createApi.post(
    '/hms/hljLocalserviceProduct/adminApi/setMeal/style/sort'
  ),

  // 获取店铺荣誉
  getMerchantHonorList: createApi(
    '/hms/merchant/appApi/admin/merchant/merchantAchievementList',
    {
      expect: undefined
    }
  ),

  // 设置商家店铺荣誉
  setMerchantHonor: createApi.post(
    '/hms/merchant/appApi/admin/merchant/setMerchantAchievement'
  ),

  // 获取店铺广告
  getMerchantRecommend: createApi(
    '/hms/merchant/appApi/admin/merchant/merchantRecommendMeal',
    {
      expect: undefined
    }
  ),

  // 设置店铺广告
  setMerchantRecommend: createApi.post(
    '/hms/merchant/appApi/admin/merchant/setMerchantRecommendMeal'
  ),
  // 获取是否显示案例模块状态（酒店）
  getHotelShowCase: createApi(
    '/hms/merchant/appApi/admin/merchant/getHotelShowCase'
  ),
  // 控制是否显示案例模块（酒店）
  setHotelShowCase: createApi.post(
    '/hms/merchant/appApi/admin/merchant/setHotelShowCase'
  )
}
